<template>
    <v-dialog v-model="showLegDialog" width="70%">

        <v-card>
            <v-card-title class="secondary white--text px-4 py-2">
                <span class="text-capitalize">Leg List</span>

                <v-spacer></v-spacer>

                <v-btn @click="showLegDialog = false" color="white" icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-2">
                <AgGridVue v-if="tripDetails.trip_legs && tripDetails.trip_legs.length"
                    style="width: 100%; height: calc(100vh - 590px)" class="ag-theme-alpine" id="tripLegGrid"
                    :columnDefs="tripLegHeaders" :defaultColDef="defaultColDef" :grid-options="gridOptions"
                    :suppressDragLeaveHidesColumns="true" :rowData="tripDetails.trip_legs"></AgGridVue>
                <p v-else class="text-center grey--text pa-6 ma-0">No leg found</p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
export default {
    components: {

        AgGridVue,


    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        tripDetails: {
            type: Object,
            default: null,
        },


    },
    computed: {
        showLegDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },


    },
    data() {
        return {
            tripLegHeaders: [
                {
                    headerName: "Leg",
                    field: "leg_id",
                    minWidth: 120,
                    onCellClicked: (params) => {
                        if (

                            params.data &&
                            params.data.trip_pk
                        ) {
                            const path = {
                                path: `/app/admin/delivery-advice/details/${params.data.da_id}`,
                                query: {},
                            };
                            this.$router.push(path);
                        }
                    },
                    cellStyle: () => {
                        return { color: "orange", fontWeight: "bold" };
                    },
                },


                {
                    headerName: "DA",
                    field: "da_no",
                    minWidth: 120,
                },
                {
                    headerName: "BOE",
                    field: "boe",
                    minWidth: 120,
                },
                {
                    headerName: "Haz",
                    field: "is_hazmat",
                    minWidth: 60,
                },
                {
                    headerName: "Gen",
                    field: "has_genset",
                    minWidth: 120,
                },
                {
                    headerName: "Container No(s)",
                    field: "leg_container_details.numbers",
                    minWidth: 220,
                    tooltipField: "leg_container_details.numbers",
                },
            ],
            defaultColDef: {
                resizable: true,
            },
            gridOptions: {
                onGridSizeChanged: () => {
                    this.resizeGrid();
                },
                suppressRowClickSelection: true,
                suppressDragLeaveHidesColumns: true,
                enableCellTextSelection: true,
                tooltipShowDelay: 0,
                rowHeight: 35,
            },

        };
    },
    watch: {

    },
    methods: {
        resizeGrid() {
            if (this.gridOptions && "api" in this.gridOptions) {
                setTimeout(() => {
                    this.gridOptions.api.sizeColumnsToFit();
                }, 100);
            }
        },
    },


};
</script>